export function toHexString(uintArray: Uint8Array, separator = ' '): string {
  return Array.from(uintArray, (byte) => byte.toString(16).padStart(2, '0')).join(separator)
}

export interface Logger {
  info: (msg: string, ...args: unknown[]) => void
  error: (msg: string, ...args: unknown[]) => void
  logHexStrNoSpace: (data: Uint8Array) => void
  logHexStr: (data: Uint8Array) => void
}

export const log: Logger = {
  info: (msg: string) => {
    console.log(msg)
  },
  error: console.error,
  logHexStrNoSpace: (data: Uint8Array) => {
    console.log(toHexString(data))
  },
  logHexStr: (data: Uint8Array) => {
    console.log(toHexString(data, ' '))
  },
}

export default log
